// extracted by mini-css-extract-plugin
export default {"NewsTitleContainer":"NewsTitle_NewsTitleContainer__0zMlK","Newstitle":"NewsTitle_Newstitle__SwMqx","extraContent":"NewsTitle_extraContent__NLOCZ"};